import { mdiPlus, mdiPencil, mdiDelete } from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import {
  fetchDelete,
  fetchGet,
  toQueryString,
} from "../../../service/api_client";
import SearchFieldWidget from "../../../ui/new_components/search_field";
import Pagination from "../../../ui/new_components/common/pagination";
import { urls } from "../../../utils/urls";
import { UnitMeasureModel } from "../models/item_unit_model";
import {
  ResponsiveListShell,
  MobileRecordCard,
  MobileRecordCardList,
  EmptyState,
} from "../../../ui/new_components/common/responsive";

interface ItemUnitListScreenProps {}

const ItemUnitListScreen: FunctionComponent<ItemUnitListScreenProps> = () => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/units`;

  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(50);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<UnitMeasureModel[]>([]);
  const [search, setSearch] = useState("");
  const fetchData = async (prop: {
    search?: string;
    page: number;
    count: number;
    all?: boolean;
  }) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setData(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData({ page, count, search });
  }, [page]);
  useEffect(() => {
    if (search) fetchData({ page, count, search });
  }, [search]);
  const navaigation = useHistory();

  const onView = (d: UnitMeasureModel) => {
    navaigation.push(urls.procurement_masters_item_unit + "/view/" + d.id);
  };
  const onSelect = (d: UnitMeasureModel) => {
    navaigation.push(urls.procurement_masters_item_unit + "/update/" + d.id);
  };
  const onDelete = async (d: UnitMeasureModel) => {
    const propmt = window.prompt("Type 'delete' to confirm.");
    if (!propmt || propmt?.trim() !== "delete") {
      return;
    }
    setLoading(true);
    const res = await fetchDelete(url + "/" + d.id);
    if (res.success) {
      await fetchData({ page, count, search });
      showToast({ type: ToastType.success, text: res.message });
    } else {
      showToast({ type: ToastType.error, text: res.error });
    }
    setLoading(false);
  };
  return (
    <>
      <ResponsiveListShell
        title="Item Units"
        count={total}
        onRefresh={() => fetchData({ page, count, search })}
        search={
          <SearchFieldWidget
            defaulValue={search}
            onClear={() => {
              setSearch("");
              fetchData({ page: 1, count });
            }}
            onSubmit={(val) => {
              fetchData({ page: 1, count, search: val });
              setPage(1);
              setSearch("");
            }}
          />
        }
        actions={
          <button
            id="add_btn"
            onClick={() => {
              navaigation.push(urls.procurement_masters_item_unit + "/create");
            }}
            className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
          >
            <Icon path={mdiPlus} className="h-4 w-4"></Icon>Add
          </button>
        }
      >
        {data.length > 0 ? (
          <>
            <div className="hidden md:block my-2 border">
              <div className="overflow-auto">
                <table
                  id="item_unit_list_table"
                  className="w-full text-xs divide-y divide-gray-200 relative"
                >
                  <thead className="text-xs py-2 bg-white z-10">
                    <tr className="border">
                      <th className="px-3 py-3 text-left">Formal Name</th>
                      <th className="px-2 py-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, i) => (
                      <tr
                        id={`item_unit_row_${item.id}`}
                        className="border text-center"
                        key={i}
                      >
                        <td
                          className="px-3 py-2 text-left cursor-pointer text-blue-600 hover:underline"
                          role="button"
                          onClick={() => onView(item)}
                        >
                          {item.formal_name}
                        </td>
                        <td>
                          <div className="flex gap-3 justify-center">
                            <button
                              id={`item_unit_row_${item.id}_edit_btn`}
                              title="Edit"
                              onClick={() => onSelect(item)}
                              className="text-gray-500 hover:text-myPrimaryColor"
                            >
                              <Icon path={mdiPencil} className="h-4 w-4" />
                            </button>
                            <button
                              id={`item_unit_row_${item.id}_delete_btn`}
                              title="Delete"
                              onClick={() => onDelete(item)}
                              className="text-gray-500 hover:text-red-500"
                            >
                              <Icon path={mdiDelete} className="h-4 w-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <MobileRecordCardList>
              {data.map((item, i) => (
                <MobileRecordCard
                  id={`item_unit_row_mobile_${item.id}`}
                  key={i}
                  onClick={() => onView(item)}
                  title={item.formal_name}
                  fields={[]}
                  actions={[
                    {
                      icon: mdiPencil,
                      title: "Edit",
                      onClick: () => onSelect(item),
                    },
                    {
                      icon: mdiDelete,
                      title: "Delete",
                      onClick: () => onDelete(item),
                      className: "hover:text-red-500",
                    },
                  ]}
                />
              ))}
            </MobileRecordCardList>

            <div
              id="item_unit_list_pagination"
              className="mt-3 sticky bottom-0 bg-white z-10 border-t flex justify-between items-center px-4 py-2"
            >
              <Pagination
                itemCount={data.length}
                page={page}
                total={total}
                count={count}
                onChange={setPage}
              />
            </div>
          </>
        ) : !loading ? (
          <EmptyState
            title="No Item Units found!"
            message="Try adjusting your search."
            imageSrc="/images/nodata.png"
          />
        ) : null}
      </ResponsiveListShell>

      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default ItemUnitListScreen;
